import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface preoperacionales {
  id?:number;
      fecha?: number;
      hora?: Date;
      cedula?: number;
      conductor?: string;
      propietario?: {
        primernombre: string;
        segundonombre: string;
        papellidos: string;
        seapellidos: string;
      };
      placa?: string;
      transito?: string;
      operacion?: string;
      soat?: string;
      cda?: string;
      rcc?: string;
      rce?: string;
      licencia?: string;
      kilometraje?: string;
      caja?: string;
      suspension?: string;
      agua?: string;
      fugas?: string;
      correas?: string;
      electricos?: string;
      espejo?: string;
      laterales?: string;
      alarma?: string;
      tapas?: string;
      frenos?: string;
      frenoe?: string;
      cinturon?: string;
      vidrios?: string;
      botiquin?: string;
      extintor?: string;
      asientos?: string;
      tablero?: string;
      estribos?: string;
      baterias?: string;
      altas?: string;
      delanteras?: string;
      traseras?: string;
      estacionarias?: string;
      stop?: string;
      llantas?: string;
      presion?: string;
      repuesto?: string;
      observaciones?: string;
      primernombre?: string;
      vehicle?: {
        interno: string;
        matricula: string;

      };
    };

@Injectable({
  providedIn: 'root'
})
export class PreoperacionalesService {
  private apiUrl =  `${environment.apiUrl}/api/preoperacionales`; 
  //private apiUrl = 'http://localhost:3000/api/preoperacionales';

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // Crear un nuevo preoperacional
  createPreoperacional(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, data, {
      headers: this.getHeaders(),
      withCredentials: true
    });
  }

  // Obtener todos los preoperacionales
  getAllPreoperacionales(): Observable<any> {
    return this.http.get(`${this.apiUrl}`, {
      withCredentials: true
    });
  }

  // Obtener uno por ID
  getPreoperacionalById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`, {
      withCredentials: true
    });
  }

  // Actualizar uno por ID
  updatePreoperacional(id: number, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data, {
      headers: this.getHeaders(),
      withCredentials: true
    });
  }

  // Eliminar por ID
  deletePreoperacional(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      headers: this.getHeaders(),
      withCredentials: true
    });
  }

getAlistamientoByPlacaYFecha(payload: {
  placa?: string;
  conductor?: string;
  fecha?: string;
  fechaFinal?: string;
}): Observable<{ preoperacional: preoperacionales[]; mensaje: string }> {
  return this.http.post<{ preoperacional: preoperacionales[]; mensaje: string }>(
    `${this.apiUrl}/buscar`,
    payload,
    { 
      headers: this.getHeaders(),
      withCredentials: true
    }
  );
}


getAlistamientoByPlacaHoja(payload: {
  placa?: string;
  conductor?: string;
  fecha?: string;
  fechaFinal?: string;
}): Observable<{ preoperacional: preoperacionales[]; mensaje: string }> {
  return this.http.post<{ preoperacional: preoperacionales[]; mensaje: string }>(
    `${this.apiUrl}/placa/hoja`,
    payload,
    { 
      headers: this.getHeaders(),
      withCredentials: true
    }
  );
}
obtenerEstadoPorFecha(fecha: string,idTipo:number): Observable<any> {
 // console.log("pasar " + idTipo);
    return this.http.get(`${this.apiUrl}/fecha/${fecha}/${idTipo}`, {
      withCredentials: true
    });
  }

  getResumenPreoperacionales(): Observable<any> {
    return this.http.get(`${this.apiUrl}/conteo`, {
      withCredentials: true
    });
  }

  informePesv(payload: { fecha?: string; fechaFinal?: string }): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/informe-pesv`, payload, {
      headers: this.getHeaders(),
      withCredentials: true,
      responseType: 'blob' as 'blob'
    });
  }

  informeTrimestralPesv(): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/trimestral-pesv`, {}, {
      headers: this.getHeaders(),
      withCredentials: true,
      responseType: 'blob' as 'blob'
    });
  }

}
